import PropTypes from "prop-types";
import React, { useEffect, useState } from "react";
import { Row, Col, Alert, Card, CardBody, Container, FormFeedback, Input, Label, Form } from "reactstrap";
import "../../assets/css/forgetpassword.css"
import regBg from '../../assets/images/login_reg/login_bg3.jpg';
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { changeforgotPassword } from "../../api/forgetpassword";
import { useSelector, useDispatch } from "react-redux";
import { createSelector } from 'reselect';
import { Link } from "react-router-dom";
import withRouter from "../../components/Common/withRouter";
import * as Yup from "yup";
import { useFormik } from "formik";
import { userForgetPassword } from "../../store/actions";

const ForgetPasswordPage = props => {
    const dispatch = useDispatch();
    document.title = "Forget Password";

    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(null);

    const validation = useFormik({
        // enableReinitialize : use this flag when initial values needs to be changed
        enableReinitialize: true,

        initialValues: {
            email: '',
        },
        validationSchema: Yup.object({
            email: Yup.string().required("Please Enter Your Email"),
        }),
        onSubmit: async (values) => {
            setLoading(true);
            setError(null);
            try {
                const requestData = {
                    Email: values.email,
                };
                const response = await changeforgotPassword(requestData);
                console.log("API Response:", response);

                // Optionally, dispatch redux action
                dispatch(userForgetPassword({ email: values.email }, props.router.navigate));

            } catch (err) {
                console.error("Error sending forgot password request:", err);
                setError("Failed to send reset link. Please try again.");
            } finally {
                setLoading(false);
            }
        }
    });

    const forgetpass = createSelector(
        (state) => state.forgetPassword,
        (layout) => ({
            forgetSuccessMsg: layout.forgetSuccessMsg,
        })
    );
    // Inside your component
    const { forgetSuccessMsg, forgetError } = useSelector(forgetpass);

    return (
        <div
            className="bg-pattern d-flex flex-column"
            style={{ backgroundImage: `url(${regBg})` }}
        >

            <ToastContainer
                position="top-right"
                autoClose={3000}
                hideProgressBar={false}
                newestOnTop={false}
                closeOnClick
                pauseOnHover
                draggable
                theme="colored"
            />

            <div className="account-pages flex-grow-1 pb-5 main-background">
                <Container>
                    <Row className="justify-content-center">
                        <Col md={8} lg={6} xl={5}>
                            <Card className="overflow-hidden">
                                {/* <div className="bg-primary bg-primary-subtle">
                                    <Row style={{ backgroundColor: "white", height: "100px" }}>
                                    </Row>
                                </div> */}
                                <CardBody className="pt-4 pb-4" style={{ backgroundColor: "white" }}>
                                    <div className="p-2">
                                        {/* Title and Description */}
                                        <div className="text-center mb-4">
                                            <h4 className="fw-bold mb-2">Forgot Password</h4>
                                            <p className="text-muted mb-4">
                                                Enter your email and we’ll send you a link to reset your password.
                                            </p>
                                        </div>

                                        {/* Alerts */}
                                        {forgetError && (
                                            <Alert color="danger" style={{ marginTop: "13px" }}>
                                                {forgetError}
                                            </Alert>
                                        )}
                                        {forgetSuccessMsg && (
                                            <Alert color="success" style={{ marginTop: "13px" }}>
                                                {forgetSuccessMsg}
                                            </Alert>
                                        )}

                                        {/* Form */}
                                        <Form
                                            className="form-horizontal"
                                            onSubmit={(e) => {
                                                e.preventDefault();
                                                validation.handleSubmit();
                                                return false;
                                            }}
                                        >
                                            <div className="mb-3">
                                                <Label className="form-label">Email</Label>
                                                <Input
                                                    name="email"
                                                    className="form-control"
                                                    placeholder="Enter email"
                                                    type="email"
                                                    onChange={validation.handleChange}
                                                    onBlur={validation.handleBlur}
                                                    value={validation.values.email || ""}
                                                    invalid={
                                                        validation.touched.email && validation.errors.email ? true : false
                                                    }
                                                />
                                                {validation.touched.email && validation.errors.email ? (
                                                    <FormFeedback type="invalid">
                                                        <div>{validation.errors.email}</div>
                                                    </FormFeedback>
                                                ) : null}
                                            </div>

                                            <Row className="button-row">
                                                <div className="d-grid mt-4">
                                                    <button
                                                        className="btn btn-primary waves-effect waves-light"
                                                        type="submit"
                                                    >
                                                        Reset
                                                    </button>
                                                </div>
                                            </Row>
                                        </Form>
                                    </div>

                                    <div className="text-center">
                                        <p>
                                            Go back to{" "}
                                            <Link to="/login" className="font-weight-medium text-primary ">
                                                Login
                                            </Link>{" "}
                                        </p>
                                    </div>
                                </CardBody>
                            </Card>
                        </Col>
                    </Row>
                </Container>
            </div>
        </div>

    );
};

ForgetPasswordPage.propTypes = {
    history: PropTypes.object,
};

export default withRouter(ForgetPasswordPage);
